(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadHospitalization', LeadHospitalization);

    LeadHospitalization.$inject = ['$resource', 'DateUtils'];

    function LeadHospitalization ($resource, DateUtils) {
        var resourceUrl =  'api/lead-hospitalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.diagnosisDate = DateUtils.convertLocalDateFromServer(data.diagnosisDate);
                        data.possibleDischargeDate = DateUtils.convertLocalDateFromServer(data.possibleDischargeDate);
                        data.hospitalizationDate = DateUtils.convertLocalDateFromServer(data.hospitalizationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.diagnosisDate = DateUtils.convertLocalDateToServer(data.diagnosisDate);
                    data.possibleDischargeDate = DateUtils.convertLocalDateToServer(data.possibleDischargeDate);
                    data.hospitalizationDate = DateUtils.convertLocalDateToServer(data.hospitalizationDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.diagnosisDate = DateUtils.convertLocalDateToServer(data.diagnosisDate);
                    data.possibleDischargeDate = DateUtils.convertLocalDateToServer(data.possibleDischargeDate);
                    data.hospitalizationDate = DateUtils.convertLocalDateToServer(data.hospitalizationDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
